import { createContext, useContext } from 'react';

export const ColorModeContext = createContext({
  mode: 'system',
  resolvedMode: 'light',
  setMode: () => {},
});

export const useColorMode = () => useContext(ColorModeContext);
